import { useQuery } from '@tanstack/react-query';
import httpClient from '../services/http-client';

export interface WorkflowAuditLogDto {
  id: string;
  workflowId: string;
  changeType: string;
  entityType: string;
  changedFields: string | null;
  oldValues: string | null;
  newValues: string | null;
  changedBy: string;
  changedByEmail: string | null;
  changedByName: string | null;
  changedAt: string;
  ipAddress: string | null;
  userAgent: string | null;
  reason: string | null;
  version: number;
}

export const workflowAuditQueryKeys = {
  all: ['workflow-audit-logs'] as const,
  lists: () => [...workflowAuditQueryKeys.all, 'list'] as const,
  list: (divisionId: string, workflowId: string, params: { limit?: number; offset?: number }) => 
    [...workflowAuditQueryKeys.lists(), divisionId, workflowId, params] as const,
};

/**
 * Hook to fetch workflow audit logs
 */
export function useWorkflowAuditLogs(
  divisionId: string,
  workflowId: string,
  params?: {
    limit?: number;
    offset?: number;
  }
) {
  return useQuery({
    queryKey: workflowAuditQueryKeys.list(divisionId, workflowId, params || {}),
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      if (params?.limit) queryParams.append('limit', params.limit.toString());
      if (params?.offset) queryParams.append('offset', params.offset.toString());
      
      const response = await httpClient.get<WorkflowAuditLogDto[]>(
        `/api/divisions/${divisionId}/workflows/${workflowId}/audit-logs?${queryParams.toString()}`
      );
      return response;
    },
    enabled: !!divisionId && !!workflowId,
  });
}
